import { Component, Vue, Watch } from "vue-property-decorator";
import { customSleep } from "@/utils/common";
import router from "@/router";
import { AppStore } from "@/store/namespace";

/**
 * 缓存页面切换动画
 */
@Component
export default class PageTransitionMx extends Vue {
  @AppStore.State routeBack: boolean;
  @AppStore.State pageTransitionName: string;
  @AppStore.Mutation setRouteBackMutation: Function;

  // protected transitionName = "slide-fade";
  // protected transitionName = "slide-right";

  get transitionName() {
    return this.pageTransitionName;
  }

  @Watch("$route")
  onRouteChange(to, from) {
    // 一加载首次，不用滑动效果
    // if (from.path === "/") return;
    // // 切换动画
    // if (this.routeBack) {
    //   this.transitionName = "slide-left";
    // } else {
    //   this.transitionName = "slide-right";
    // }
    // // 初始化状态
    // setTimeout(() => {
    //   this.setRouteBackMutation();
    // });
  }

  created() {
    // 调用history.pushState()或history.replaceState()不会触发popstate事件。
    // 返回调用的是history.back(),会触发popstate事件
    window.addEventListener("popstate", event => {
      // console.log("popstate");
      // this.setRouteBackMutation(true);
    });
    // 初始化状态
    // this.setRouteBackMutation();
  }
}
